<div class="row">
  <form
    class="consult-form"
    [formGroup]="filtrosBusqueda"
    (ngSubmit)="onSubmit()"
  >
    <div class="form-container row">
      <div class="col-12">
        <div class="row">
          <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 form-item">
            <mat-form-field style="width: 100%">
              <mat-label>Número de solicitud</mat-label>
              <input
                matInput
                type="text"
                formControlName="numeroSolicitud"
                inputmode="numeric"
                pattern="[0-9]*"
                (keypress)="onNumeroSolicitudKeyPress($event)"
                (input)="onNumeroSolicitudInput($event)"
              />
            </mat-form-field>
          </div>

          <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 form-item">
            <mat-form-field style="width: 100%">
              <mat-label>Tipo de novedad de traslado</mat-label>
              <mat-select formControlName="tipoNovedadTraslado" multiple>
                <mat-option
                  *ngFor="let tipoNovedad of tiposNovedad"
                  [value]="tipoNovedad"
                >
                  {{ tipoNovedad }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 form-item">
            <mat-form-field style="width: 100%">
              <mat-label>Subtipo de novedad de traslado</mat-label>
              <mat-select formControlName="subtipoNovedadTraslado" multiple>
                <mat-option
                  *ngFor="let subtipoNovedad of subtiposNovedad"
                  [value]="subtipoNovedad"
                >
                  {{ subtipoNovedad }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div
            class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 form-item mb-3"
          >
            <button type="submit" class="btn btn-primary btn-icon w-100">
              <span>Aplicar filtro</span>
            </button>
          </div>

          <div
            class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 form-item mb-3"
          >
            <button
              type="button"
              class="btn btn-outline-primary btn-icon w-100"
              (click)="onReset()"
            >
              <span>Limpiar filtro</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
  <div
    *ngIf="isLoading"
    class="d-flex justify-content-center align-items-center py-4"
  >
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Cargando...</span>
    </div>
    <span class="ms-2 text-muted">Cargando solicitudes radicadas...</span>
  </div>

  <div *ngIf="errorMsg" class="alert alert-danger mt-3">{{ errorMsg }}</div>

  <app-table
    *ngIf="!isLoading && !errorMsg"
    [attrData]="attrData"
    [namesColumns]="namesColumns"
    [data]="tableData"
  ></app-table>
</div>
